import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Table, Form, Input, Select, Button, Space, Typography, Tag, Badge, Cascader, Radio } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const mockData = [
  { key: '1', productName: '0129产品创建', productId: 'P2MYHLjna9', source: 'self', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7', prodFwCount: 2, upgFwCount: 1, lastUpdate: '2026-04-10 14:30:00', hasNewVersion: false },
  { key: '2', productName: '01281615产品创建', productId: 'Pm38jEddh2', source: 'self', enterpriseName: '东莞康林物联网有限公司', enterpriseId: 'JGSf0Nd7', prodFwCount: 1, upgFwCount: 0, lastUpdate: '2026-04-08 09:00:00', hasNewVersion: false },
  { key: '3', productName: '0128产品创建', productId: 'PHWEu9JFZd', source: 'self', enterpriseName: '捷顺科技股份有限公司', enterpriseId: 'A619355x', prodFwCount: 1, upgFwCount: 1, lastUpdate: '2026-04-05 16:20:00', hasNewVersion: false },
  { key: '5', productName: '4G类目下低功耗产品', productId: 'Pg7yYSNj3n', source: 'self', enterpriseName: '捷顺科技股份有限公司', enterpriseId: 'A619355x', prodFwCount: 3, upgFwCount: 2, lastUpdate: '2026-04-01 11:00:00', hasNewVersion: false },
  { key: '8', productName: '智能云台摄像机-康林高配版', productId: 'P_DRV_001', source: 'ecosystem', enterpriseName: '深圳芯视界科技有限公司', enterpriseId: 'ENT_V01', prodFwCount: 2, upgFwCount: 1, lastUpdate: '2026-04-18 14:00:00', hasNewVersion: true },
  { key: '9', productName: '智能云台摄像机-康林低配版', productId: 'P_DRV_002', source: 'ecosystem', enterpriseName: '深圳芯视界科技有限公司', enterpriseId: 'ENT_V01', prodFwCount: 2, upgFwCount: 1, lastUpdate: '2026-04-18 14:00:00', hasNewVersion: false },
];

const FirmwareNew = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [role, setRole] = useState('platform');
  const isPlatform = role === 'platform';

  const columns = [
    {
      title: '产品信息', key: 'product', width: 300,
      render: (_, r) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div>
            <div style={{ fontWeight: 500, fontSize: 14 }}>
              {r.productName}
              {r.hasNewVersion && r.source !== 'ecosystem' && <Badge count="新版本" style={{ backgroundColor: '#ff4d4f', marginLeft: 8, fontSize: 11 }} />}
            </div>
            <Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text>
          </div>
        </div>
      ),
    },
    ...(isPlatform ? [{
      title: '所属企业', key: 'enterprise', width: 200,
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500 }}>{r.enterpriseName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>{r.enterpriseId}</Text>
        </div>
      ),
    }] : []),
    {
      title: '产品来源', key: 'source', width: 100,
      render: (_, r) => {
        let color = 'green';
        let text = '自研';
        if (r.source === 'ecosystem') { color = 'blue'; text = '方案派生'; }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    { title: '生产固件', dataIndex: 'prodFwCount', width: 90, render: (v) => `${v} 个` },
    { title: '升级固件', dataIndex: 'upgFwCount', width: 90, render: (v) => `${v} 个` },
    { title: '最后更新', dataIndex: 'lastUpdate', width: 170, render: (v) => v || <Text type="secondary">暂无</Text> },
    {
      title: '操作', key: 'action', width: 130,
      render: (_, r) => (
          <Button type="link" size="small" onClick={() => {
            const params = `productId=${r.productId}&productName=${encodeURIComponent(r.productName)}&source=${r.source}`;
            const extra = isPlatform ? `&enterpriseName=${encodeURIComponent(r.enterpriseName || '')}&enterpriseId=${r.enterpriseId || ''}` : '';
            navigate(`/firmware/version?${params}${extra}`);
          }}>管理固件</Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>固件管理</Title>
        <Space>
          <Text type="secondary">Mock角色：</Text>
          <Radio.Group value={role} onChange={e => setRole(e.target.value)} optionType="button" buttonStyle="solid" size="small">
            <Radio.Button value="enterprise">企业角色</Radio.Button>
            <Radio.Button value="platform">平台角色</Radio.Button>
          </Radio.Group>
        </Space>
      </div>

      <Card bordered={false}>
        <Form form={form} layout="inline" style={{ marginBottom: 16, gap: '8px 0' }}>
          {isPlatform && (
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="entSearchType" initialValue="name" noStyle>
                  <Select style={{ width: 100 }}>
                    <Select.Option value="name">企业名称</Select.Option>
                    <Select.Option value="id">企业ID</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.entSearchType !== c.entSearchType} noStyle>
                  {({ getFieldValue }) => getFieldValue('entSearchType') === 'id'
                    ? <Form.Item name="enterprise" noStyle><Input placeholder="企业ID" allowClear style={{ width: 200 }} /></Form.Item>
                    : <Form.Item name="enterprise" noStyle><Input placeholder="企业名称" allowClear style={{ width: 200 }} /></Form.Item>
                  }
                </Form.Item>
              </Space.Compact>
            </Form.Item>
          )}
          <Form.Item style={{ marginRight: 8 }}>
            <Space.Compact>
              <Form.Item name="searchType" initialValue="name" noStyle>
                <Select style={{ width: 100 }}>
                  <Select.Option value="name">产品名称</Select.Option>
                  <Select.Option value="id">产品ID</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item shouldUpdate={(p, c) => p.searchType !== c.searchType} noStyle>
                {({ getFieldValue }) => getFieldValue('searchType') === 'id'
                  ? <Form.Item name="keyword" noStyle><Input placeholder="产品ID" allowClear style={{ width: 200 }} /></Form.Item>
                  : <Form.Item name="keyword" noStyle><Input placeholder="产品名称" allowClear style={{ width: 200 }} /></Form.Item>
                }
              </Form.Item>
            </Space.Compact>
          </Form.Item>
          <Form.Item name="source" style={{ marginRight: 8 }}>
            <Cascader placeholder="产品来源" allowClear changeOnSelect style={{ width: 180 }} options={[
              { value: 'self', label: '自研' },
              { value: 'ecosystem', label: '方案派生', children: [
                { value: 'ENT_V01', label: '深圳芯视界科技有限公司' },
              ]},
            ]} />
          </Form.Item>
          <Form.Item name="hasNew" style={{ marginRight: 8 }}>
            <Select placeholder="新版本" allowClear style={{ width: 120 }}>
              <Select.Option value="yes">有新版本</Select.Option>
              <Select.Option value="no">无新版本</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
        </Form>
        <Table columns={columns} dataSource={mockData} rowKey="key"
          scroll={{ x: isPlatform ? 1100 : 900 }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>
    </div>
  );
};

export default FirmwareNew;
